module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-wrap"
  }, [(_vm.myTeamGroups.length > 0) ? _c('button', {
    staticClass: "channelBtn btn bg-lightest darker bold mr-2 mb-2",
    class: {
      'selected': _vm.value.length > 0 && _vm.value[0].channelType == 9999
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectChannel('myTeam')
      }
    }
  }, [_vm._v("\n        My team\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.regularChannels), function(salesChannel) {
    return _c('button', {
      key: salesChannel.id,
      staticClass: "channelBtn btn bg-lightest darker bold mr-2 mb-2",
      class: {
        'selected': _vm.value.length > 0 && _vm.value[0].id == salesChannel.id
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectChannel(salesChannel)
        }
      }
    }, [_vm._v("\n        " + _vm._s(salesChannel.name) + "\n    ")])
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5fa79694", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fa79694"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationRefundTransaction/ChannelSelector.vue
// module id = 2129
// module chunks = 0